export default __webpack_public_path__ + "static/media/Recreation_Logotipo vetorizado_V1_MONO WHT.273653bc.svg";